import React from 'react';
import { Avatar, IconButton } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import styles from './index.module.scss';

const ContactItem = (props: any) => {
    const { contact } = props;

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <Avatar className={styles.avatar}>{contact.initial}</Avatar>
                <div className={styles.user}>
                    <div className={styles.name}>{contact.name}</div>
                    <div className={styles.title}>{contact.title}</div>
                </div>
            </div>
            <div className={styles.actions}>
                <IconButton>
                    <CloseIcon></CloseIcon>
                </IconButton>
            </div>
        </div>
    );
};

export default ContactItem;
